import { userEditComponent } from "./user-edit.component";
export const userEdit = angular
  .module("components.user.userEdit", [])
  .component("userEdit", userEditComponent)
  .config(($stateProvider) => {
    "ngInject";

    $stateProvider.state("userEdit", {
      parent: "app",
      url: "/home/user/:id/edit",
      breadcrumbName: "edit member",
      parentState: "user",
      component: "userEdit",
      resolve: {
        branchOfServiceList(BranchOfService) {
          "ngInject";
          return BranchOfService.getBranchOfServiceList();
        },
        rankList(RankService) {
          "ngInject";
          return RankService.getRankList();
        },
        statusList(VeteranStatusService) {
          "ngInject";
          return VeteranStatusService.getStatusList();
        },
        details($stateParams, UserService) {
          "ngInject";
          return UserService.getUserDetailsById($stateParams.id);
        },
      },
    });
  }).name;



// WEBPACK FOOTER //
// ./src/app/components/user/user-edit/user-edit.module.js